
const secondStepData = {
    otp: '',
    email_id: ''
  };

  export default secondStepData;